import React from "react";
import Navbar from "../components/landing/Navbar";

import HeroSection from "../components/landing/HeroSection";
import AboutSection from "../components/landing/AboutSection";
import MarqueeSection, { PartnersMarquee } from "../components/landing/MarqueeSection";
import FeaturesSection from "../components/landing/FeaturesSection";
import HowToBuySection from "../components/landing/HowToBuySection";
import TokenomicsSection from "../components/landing/TokenomicsSection";
import RoadmapSection from "../components/landing/RoadmapSection";
import FAQSection from "../components/landing/FAQSection";
import Footer from "../components/landing/Footer";

const LandingPage = () => {
  return (
    <div className="min-h-screen bg-[#060d06] text-white">
      <Navbar />

      <HeroSection />
      <AboutSection />
      <MarqueeSection variant="primary" />
      <FeaturesSection />
      <HowToBuySection />
      <PartnersMarquee />
      <TokenomicsSection />
      <RoadmapSection />
      <FAQSection />
      <Footer />
    </div>
  );
};

export default LandingPage;
